export type PolicyOutcome = 'GRANT' | 'DENY' | 'POLICY_DOCUMENT_NOT_FOUND' | 'POLICY_DOCUMENT_ERROR';

export const PolicyOutcome = {
  GRANT: 'GRANT' as PolicyOutcome,
  DENY: 'DENY' as PolicyOutcome,
  POLICYDOCUMENTNOTFOUND: 'POLICY_DOCUMENT_NOT_FOUND' as PolicyOutcome,
  POLICYDOCUMENTERROR: 'POLICY_DOCUMENT_ERROR' as PolicyOutcome,
};
